import _ from 'underscore';
import ko from 'knockout';
import { bulkApiErrorNumberToErrorMessageMapping } from '@bingads-webui-campaign/api-errors';
import {
  APPLY_ACTION_TYPES,
  RECOMMENDATION_NOTIFICATION_ERRORCODE,
  RECOMMENDATION_TYPES,
  CAMPAIGN_ODATA_ERROR_BASELINE,
} from '@bingads-webui-campaign/recommendation-core';

export default class ViewModel {
  constructor({
    i18n,
    newI18n,
    aggregatedResult,
    recommendationType,
    formatNotificationLocalizedKey,
  }) {
    this.i18n = i18n;
    this.newI18n = newI18n;
    this.recommendationType = recommendationType;
    this.formatNotificationLocalizedKey = formatNotificationLocalizedKey;
    this.showNotificationPanel = ko.observable(false);
    this.aggregatedResult = ko.observable(aggregatedResult || {});
    this.totalCount = ko.pureComputed(() => this.aggregatedResult().totalCount);

    this.successTotalCount = ko.pureComputed(() => this.aggregatedResult().successfulCount);
    this.failTotalCount = ko.pureComputed(() => this.aggregatedResult().failedCount);

    this.failHeadingDescText = ko.observable('');

    this.otherInfo = ko.pureComputed(() => this.aggregatedResult().otherInfo);

    if (this.recommendationType === RECOMMENDATION_TYPES.FIX_AD_DESTINATION) {
      this.failHeadingDescText(i18n.getString('Recommendation_Lightbox_Fail_Header_Desc_Fix_Ad_Destination_Message'));
    }

    this.successHeadingText = ko.pureComputed(() =>
      this.i18n.getString(
        this.formatNotificationLocalizedKey({
          count: this.successTotalCount(),
          isSuccess: true,
          recommendationType: this.recommendationType,
          actionType: APPLY_ACTION_TYPES.ACCEPT,
          otherInfo: this.otherInfo(),
        }),
        { n: this.successTotalCount(), ...this.otherInfo() }
      ));
    this.failHeadingText = ko.pureComputed(() =>
      this.i18n.getString(
        this.formatNotificationLocalizedKey({
          count: this.failTotalCount(),
          isSuccess: false,
          recommendationType: this.recommendationType,
          actionType: APPLY_ACTION_TYPES.ACCEPT,
          otherInfo: this.otherInfo(),
        }),
        { n: this.failTotalCount(), ...this.otherInfo() }
      ));

    this.failCountsByErrorCode = ko.pureComputed(() => {
      if (this.recommendationType === RECOMMENDATION_TYPES.REPAIR_ADS ||
        this.recommendationType === RECOMMENDATION_TYPES.REPAIR_KEYWORD ||
        this.recommendationType === RECOMMENDATION_TYPES.FIX_AD_DESTINATION) {
        return [];
      }
      return _.chain(this.aggregatedResult().AggregatedResults)
        .filter(result => result.ErrorCode !== 0)
        .sortBy('RecommendationCount')
        .reverse()
        .map(error => ({
          reason: this.i18n.getString('Recommendation_Notification_Fail_Reason', {
            count: error.RecommendationCount,
            totalCount: this.failTotalCount(),
            reason: this.getReasonByErrorCode(error.ErrorCode),
          }),
          errorCode: error.ErrorCode,
          ..._.defaults(_.pick(
            RECOMMENDATION_NOTIFICATION_ERRORCODE[`Recommendation_Error_${error.ErrorCode}`],
            'hasLearnMore',
            'helpId'
          ), {
            hasViewRec: error.Expired,
            hasLearnMore: false,
            helpId: null,
          }),
        }))
        .value();
    });
  }

  getReasonByErrorCode(errorCode) {
    if (RECOMMENDATION_NOTIFICATION_ERRORCODE[`Recommendation_Error_${errorCode}`]) {
      return this.i18n.getString(`Recommendation_Error_${errorCode}`);
    }
    if (errorCode >= CAMPAIGN_ODATA_ERROR_BASELINE) {
      const CMMTErrorCode = errorCode - CAMPAIGN_ODATA_ERROR_BASELINE;
      let errorMessage;
      const i18nKey = bulkApiErrorNumberToErrorMessageMapping[`API_ErrorNumber_${CMMTErrorCode}`];
      if (!_.isUndefined(i18nKey)) {
        errorMessage = this.newI18n.getString(i18nKey);
      }
      return !_.isUndefined(errorMessage) ?
        errorMessage :
        this.i18n.getString('Recommendation_Error_Generic_Failure');
    }
    return this.i18n.getString('Recommendation_Error_Generic_Failure');
  }
}
